export const tokenize = (s,t=' ') => s.split(t)
export const head  = (s, wordcount, ellipsis="") => {
    const t = tokenize(s);
    return t.slice(0, wordcount).join(' ') + (t.length > wordcount ? ellipsis : '')
}
export const tail = (s, wordcount) => tokenize(s).slice(wordcount).join(' ')
export const wordcount = s => tokenize(s).length
export const join = (ss,j=' ') => ss.map(s=>(s||"").trim()).join(j)
export const capitalize = s => s.substr(0,1).toUpperCase() + s.substr(1)



// WEBPACK FOOTER //
// ./src/nlp.js